const ROLES = {
  USER: {
    name: 'user',
    string: 'User',
    value: 1,
  },
  ADMINISTRATOR: {
    name: 'administrator',
    string: 'Administrator',
    value: 2,
  },
  POWER_USER: {
    name: 'poweruser',
    string: 'Power User',
    value: 2,
  },
  ORGANIZATION_USER: {
    name: 'organizationuser',
    string: 'Organization User',
    value: 1,
  },
  COMMITTE_MEMBER: {
    name: 'committeemember',
    string: 'Committe Member',
    value: 1,
  },
  CONTENT_EDITOR: {
    name: 'contenteditor',
    string: 'Content Editor',
    value: 1,
  },
  EXTERNAL_EXPERT: {
    name: 'externalexpert',
    string: 'External Expert',
    value: 1,
  },
};

export default ROLES;
